import React from 'react'
import { HiMiniArrowLeft } from 'react-icons/hi2'
import { useHistory } from 'react-router'
import { mobileAssets } from 'src/containers/PreCache'
import styled from 'styled-components'

type MobileLayoutProps = {
  children: React.ReactNode
  title: string
  route?: string
}

export default function MobileLayout({ children, title, route = '/lobby' }: MobileLayoutProps) {
  const history = useHistory()

  const handleGoBack = () => {
    history.push(route)
  }

  return (
    <BgPage>
      <Wrapper>
        <Header>
          <div role="button" className="d-flex align-items-center" onClick={handleGoBack}>
            <HiMiniArrowLeft />
          </div>
          <h1 className="">{title}</h1>
        </Header>

        <div id="mobileContent">{children}</div>
      </Wrapper>
    </BgPage>
  )
}

const Header = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 14px 16px;
  color: var(--blue-01);

  h1 {
    flex: 1;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    margin: 0;
  }

  div[role='button'] {
    position: absolute;
    font-size: 24px;
    font-weight: 700;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    transition: all 0.2s ease-in-out;

    &:active {
      transform: scale(1.1);
    }
  }
`

const Wrapper = styled.div`
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(5px);
  min-height: 100dvh;

  #mobileContent {
    padding: 16px;
  }

  .grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (min-width: 768px) {
    .grid-container {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`

const BgPage = styled.div`
  background-image: url('${mobileAssets.mobileBg}');
  background-size: cover;
  min-height: 100dvh;
`
